<template>
  <div class="reportPage">
    <div class="reportPageHeader secondary">
      <div class="reportPageHeaderProjects">
        <v-autocomplete attach class="mr-2" hide-details hide-no-data :items="this.currentUser.projects" v-model="projectUuid" item-text="name" item-value="uuid" hint=""></v-autocomplete>
      </div>
      <div class="reportPageHeaderDateTime">
        <div>From</div>
        <v-menu attach offset-y left :close-on-content-click="false">
          <div slot="activator" class="accent white--text pa-3" prepend-icon="event" v-html="fromDate + ' ' + fromTime"></div>
          <v-date-picker
            v-model="fromDate"
            :options="dateRangeOptions" 
            @input="onDateRangeChange"
            header-color="#424242"
            style="background: white !important; padding-top: 35px !important; padding-bottom: 35px !important;">
          </v-date-picker>
          <v-time-picker
            v-model="fromTime"
            @input="onTimeRangeChange"
            :scrollable="true"
            header-color="#424242"
            format="24hr"
            style="background: white !important; padding-top: 35px !important; padding-bottom: 35px !important;">
          </v-time-picker>
        </v-menu>
        <div>To</div>
        <v-menu attach offset-y left :close-on-content-click="false">
          <div slot="activator" class="accent white--text pa-3" prepend-icon="event" v-html="toDate + ' ' + toTime"></div>
          <v-date-picker
            v-model="toDate"
            :options="dateRangeOptions" 
            @input="onDateRangeChange"
            header-color="#424242"
            style="background: white !important; padding-top: 35px !important; padding-bottom: 35px !important;">
          </v-date-picker>
          <v-time-picker
            v-model="toTime"
            format="24hr"
            @input="onTimeRangeChange"
            :scrollable="true"
            header-color="#424242"
            style="background: white !important; padding-top: 35px !important; padding-bottom: 35px !important;">
          </v-time-picker>
        </v-menu>
      </div>
      <div class="reportPageHeaderReportType">
        <v-autocomplete attach class="mr-2" hide-details hide-no-data :items="reportTypes" v-model="reportType" item-text="name" item-value="type" hint=""></v-autocomplete>
      </div>
    </div>
    <div class="reportPageContainer">
      <div class="reportEditorContainer">
        <div class="reportEditorContentHeader">
          <div class="reportEditorContentHeader">
            <div class="reportEditorContentHeaderReportType">General Monitoring Report</div>
            <div class="reportEditorContentHeaderReportProjectName">{{projectName}}</div>
            <div class="reportEditorContentHeaderReportPeriod">{{'Period from ' + fromDate + ' ' + fromTime}}<br>{{'until ' + toDate + ' ' + toTime}}</div>
          </div>
        </div>
        <div class="reportEditorContentOverview">
          <div class="reportEditorContentOverviewTitle">Overview / Executive summary</div>
          <div class="reportEditorContentOverviewInput">
            <v-textarea v-model="reportEditorContentOverviewInput" solo label="Overview / Executive summary" class="reportEditorContentOverviewInputTextarea"></v-textarea>
          </div>
        </div>
        <div class="tweetTypesVolumeLineChart" id="tweetTypesVolumeLineChart" ref="tweetTypesVolumeLineChart">
          <TweetVolume v-on:chart-ready="getImageDataTweetTypeVolume('tweetTypesVolumeLineChart')" v-bind:options="{projectUuid: projectUuid, fromDate: fromDate, fromTime: fromTime, toDate: toDate, toTime: toTime}"></TweetVolume>
        </div>
        <div class="reportEditorContentOverviewTitle">This is another chart.</div>
        <div class="reportEditorContentOverview">
          <div class="reportEditorContentOverviewInput">
            <v-textarea v-model="reportEditorContentEmojiInput" solo label="Overview / Executive summary" class="reportEditorContentOverviewInputTextarea"></v-textarea>
          </div>
        </div>
        <div class="reportEmojiCloud" id="reportEmojiCloud" ref="reportEmojiCloud">
          <EmojiCloud style="height: 300px;" v-on:chart-ready="getImageDataEmojiCloud('reportEmojiCloud')" v-bind:options="{projectUuid: projectUuid, fromDate: fromDate, fromTime: fromTime, toDate: toDate, toTime: toTime}"></EmojiCloud>
        </div>
      </div>
      <div class="reportPreviewContainer accent" id="reportPreviewContainer">
        <div class="reportPreviewContentContainer white">
          <div class="reportPreviewContentHeader">
            <div class="reportPreviewContentHeaderReportType">General Monitoring Report</div>
            <div class="reportPreviewContentHeaderReportProjectName">{{projectName}}</div>
            <div class="reportPreviewContentHeaderReportPeriod">{{'Period from ' + fromDate + ' ' + fromTime}}<br>{{' until ' + toDate + ' ' + toTime}}</div>
          </div>
          <div class="mainReportPage">
            <div style="font-size: 42px; font-weight: bold;">{{projectName}}</div><br>
            <div style="font-size: 28px;">General Monitoring Report</div>
            <div style="font-size: 28px; font-style: italic; text-align: center;">{{'Period from ' + fromDate + ' ' + fromTime}}<br>{{' until ' + toDate + ' ' + toTime}}</div><br>
            <div style="font-size: 28px; font-style: italic;">By</div><br>
            <div style="width: 80%;"><img style="max-width: 100%;" src="@/assets/yakshof.png"></div>
          </div>
          <div class="mainReportPage">
            <div style="font-size: 36px; font-weight: bold">Overview</div>
          </div>
          <div class="reportViewContent">
            <div class="reportViewContentOverview" id="reportViewContent"><br>
              <div class="reportViewContentOverviewTitle"><b>Overview / Executive summary</b></div><br>
              <div class="reportViewContentOverviewText" v-html="reportEditorContentOverviewInputFormatted"></div><br>
            </div>
            <div class="reportViewContentOverviewImage">
              <img :src="tweetTypesVolumeLineChartDataImage">
            </div><br>
            <div>
            </div>
          </div>
          <div class="reportViewContent">
            <div class="reportViewContentOverview" id="reportViewContent2"><br>
              <div class="reportViewContentOverviewTitle">This is another chart.</div><br>
              <div class="reportViewContentOverviewText" v-html="reportEditorContentEmojiInputFormatted"></div><br>
            </div>
            <div class="reportViewContentOverviewImage">
              <img :src="reportEmojiCloudDataImage">
            </div><br>
          </div>
        </div>
        <div style="text-align: center">
          <v-btn flat class="primary mt-4" @click="savePDF">Save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .reportPageHeaderProjects .v-text-field{
    padding-top: 0 !important;
  }
  .mainReportPage{
    height: 800px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .reportEmojiCloud{
    display: flex;
    justify-content: center;
  }
  .reportPreviewContentHeaderReportPeriod, .reportEditorContentHeaderReportPeriod{
    text-align: right;
  }
  .reportPageHeaderDateTime .v-time-picker-title__time .v-picker__title__btn, .reportPageHeaderDateTime .v-time-picker-title__time span{
    height: 55px !important;
    font-size: 45px !important;
  }
  .reportPageHeaderDateTime .v-time-picker-title{
    justify-content: center;
  }
  .reportPageHeaderDateTime .v-time-picker-clock{
    margin: 0 !important;
  }
  .reportPageHeaderDateTime .v-menu__content{
    background-color: white !important;
  }
  .reportPageHeaderDateTime .v-picker{
    box-shadow: none !important;
  }
  .reportPageHeaderDateTime{
    display: flex;
    align-items: center;
  }
  .reportPageHeaderDateTime div{
    margin: 0 10px;
  }
  .reportPageHeader{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
  }
  .reportPageHeaderProjects{
    width: 200px;
  }
  .reportEditorContentHeaderReportProjectName{
    font-weight: bold;
  }
  .tweetTypesVolumeLineChart{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .reportEditorContentOverviewTitle, .reportEditorContentOverviewTitle{
    margin: 30px 0;
    font-size: 16px;
    font-weight: bold;
  }
  .reportEditorContentOverviewInputTextarea{
    width: 100%;
  }
  .reportPageHeader{
    height: 80px;
    width: calc(100% - 20px);
    margin: 20px 10px;
  }
  .reportViewContentOverviewText, .reportViewContentOverviewTextEmoji{
    padding-bottom: 10px;
  }
  .reportViewContentOverviewImage{
    overflow: hidden;
    text-align: center;
  }
  .reportViewContentOverviewImage img{
    max-width: 100%;
    height: auto;
  }
  .reportPreviewContentHeaderReportProjectName{
    font-weight: bold;
  }
  .reportViewContentOverviewTitle{
    font-size: 11px;
    margin-top: 10px;
    font-weight: bold;
  }
  .reportEditorContentOverviewInputTextarea{
    width: 90%;
    margin-left: 5%;
  }
  .reportPageContainer{
    width: 100%;
    height: 100%;
    display: flex;
  }
  .reportEditorContainer{
    width: calc(100% - 550px);
    height: 100%;
    padding: 20px;
    overflow-y: auto;
  }
  .reportPreviewContainer{
    width: 550px;
    height: 100%;
    padding: 20px;
    overflow-y: auto;
  }
  .reportPreviewContentContainer{
    width: 100%;
    height: 100%;
    padding: 30px 10px;
    font-size: 11px;
  }
  .reportEditorContentHeader, .reportPreviewContentHeader{
    width: 100%;
    display: flex;
    /*align-items: center;*/
    justify-content: space-between;
  }
</style>

<script>
import jsPDF from 'jspdf'
import { mapGetters } from 'vuex'
// import html2canvas from 'html2canvas'
import { getImage } from '@/helpers/imageData'
import TweetVolume from './report/TweetVolume.vue'
// import { formatDate } from '@/helpers/formatters'
// import { format, subDays } from 'date-fns'
import config from '@/helpers/config'
import DateRange from './DateRange'
import EmojiCloud from './report/EmojiCloud.vue'

export default {
  data () {
    return {
      doc: null,
      fromDate: null,
      toDate: null,
      fromTime: null,
      toTime: null,
      projectNameUrl: '',
      projectUuid: null,
      reportTypes: [
        {
          name: 'General Monitoring Report',
          type: 'GENERAL_MONITORING_REPORT'
        }
      ],
      reportType: 'GENERAL_MONITORING_REPORT',
      reportEditorContentOverviewInput: 'This is where we introduce General Counts and Overall Activity Volume (total number of articles published, tweets, retweets, posts, etc.) to answer the intrigue about how much has been said. Then we elaborate to reveal the sentiment of what has been said and its dissemination timing by type of sources (Media, Twitter, FB, etc.).',
      reportEditorContentEmojiInput: 'This is where we introduce General Counts.',
      tweetTypesVolumeLineChartDataImage: '',
      reportEmojiCloudDataImage: '',
      dateRangeOptions: {
        startDate: this.$route.query.fromDate ? this.$route.query.fromDate : this.$store.getters['filters/getFromDate'],
        endDate: this.$route.query.toDate ? this.$route.query.toDate : this.$store.getters['filters/getToDate'],
        format: config.defaultDateFormat
      },
      yakshofLogo: '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'
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters('filters', ['getFilters']),
    projectName () {
      var project = this.currentUser.projects.find(item => { return item.uuid === this.projectUuid }).name
      return project
    },
    reportEditorContentOverviewInputFormatted () {
      var formattedText = this.reportEditorContentOverviewInput
      while (formattedText.indexOf('\n') !== -1) {
        formattedText = formattedText.replace('\n', '<br>')
      }
      while (formattedText.indexOf('<br><br>') !== -1) {
        formattedText = formattedText.replace('<br><br>', '<br> <br>')
      }
      return formattedText
    },
    reportEditorContentEmojiInputFormatted () {
      var formattedText = this.reportEditorContentEmojiInput
      while (formattedText.indexOf('\n') !== -1) {
        formattedText = formattedText.replace('\n', '<br>')
      }
      while (formattedText.indexOf('<br><br>') !== -1) {
        formattedText = formattedText.replace('<br><br>', '<br> <br>')
      }
      return formattedText
    }
  },
  components: {
    jsPDF,
    TweetVolume,
    EmojiCloud,
    DateRange
  },
  created () {
    this.projectUuid = this.$route.query.projectUuid
    this.fromDate = this.$route.query.fromDate
    this.toDate = this.$route.query.toDate
    this.fromTime = '00:00'
    this.toTime = '11:59'
  },
  methods: {
    async getImageDataTweetTypeVolume (ref) {
      this.tweetTypesVolumeLineChartDataImage = await getImage(this.$refs[ref], ref)
    },
    async getImageDataEmojiCloud (ref) {
      this.reportEmojiCloudDataImage = await getImage(this.$refs[ref], ref)
    },
    onDateRangeChange: function (range) {
    },
    onTimeRangeChange: function (range) {
      console.log(range)
    },
    savePDF () {
      this.getPDF()
    },
    getTimeRangeData: function () {
      return this.fromTime + ' - ' + this.toTime
    },
    getPDF () {
      var JSPDF = jsPDF
      this.doc = new JSPDF({
        orientation: 'p',
        format: 'a4'
      })
      this.projectNameUrl = this.projectName
      while (this.projectNameUrl.indexOf(' ') !== -1) {
        this.projectNameUrl = this.projectNameUrl.replace(' ', '_')
      }
      this.doc.setFont('helvetica', 'normal')
      this.doc.setFontSize(11)
      this.doc.setFontSize(48)
      this.doc.setFontStyle('bold')
      this.doc.text(this.projectName, 105, 100, {align: 'center'})
      this.doc.setFontSize(24)
      this.doc.setFontStyle('')
      this.doc.text('General Monitoring Report', 105, 120, {align: 'center'})
      this.doc.setFontSize(22)
      this.doc.setFontStyle('italic')
      this.doc.text('Period from ' + this.fromDate + ' ' + this.fromTime, 105, 140, {align: 'center'})
      this.doc.text('until ' + this.toDate + ' ' + this.toTime, 105, 150, {align: 'center'})
      this.doc.text('By', 105, 170, {align: 'center'})
      this.doc.addImage(this.yakshofLogo, 'png', 30, 190, 150, 24, '', 'NONE', 0)
      this.doc.addPage({
        orientation: 'p',
        format: 'a4'
      })
      this.doc.setFont('helvetica', 'normal')
      this.doc.setFontSize(36)
      this.doc.setFontStyle('bold')
      this.doc.text('Overview', 105, 160, {align: 'center'})
      this.doc.addPage({
        orientation: 'p',
        format: 'a4'
      })
      this.doc.setFont('helvetica', 'normal')
      this.doc.fromHTML(document.getElementById('reportViewContent').innerHTML, 15, 20, {
        'width': 170
      }, function () {})
      this.doc.addImage(this.tweetTypesVolumeLineChartDataImage, 'jpeg', 15, ((document.getElementById('reportViewContent').offsetHeight / 3) + 5), 180, 90, '', 'NONE', 0)
      this.doc.fromHTML(document.getElementById('reportViewContent2').innerHTML, 15, (document.getElementById('reportViewContent').offsetHeight / 3) + 105, {
        'width': 170
      }, function () {})
      this.doc.addImage(this.reportEmojiCloudDataImage, 'jpeg', 30, ((document.getElementById('reportViewContent').offsetHeight / 3) + (document.getElementById('reportViewContent2').offsetHeight / 3) + 100), 170, 90, '', 'NONE', 0)
      for (var i = 0; i < this.doc.getNumberOfPages(); i++) {
        this.doc.setPage(i + 1)
        this.doc.setFontSize(11)
        this.doc.setFontStyle('normal')
        this.doc.text('General Monitoring Report', 15, 12.7)
        this.doc.setFontStyle('bold')
        this.doc.text(this.projectName, 90, 12.7)
        this.doc.setFontStyle('italic')
        this.doc.text('Period from ' + this.fromDate + ' ' + this.fromTime, 200, 12.7, {align: 'right'})
        this.doc.text('until ' + this.toDate + ' ' + this.toTime, 200, 20, {align: 'right'})
        this.doc.setFontStyle('normal')
        var text = i + 1
        this.doc.text(text.toString(), 105, 290, {align: 'center'})
      }
      this.doc.save('GENERAL_MONITORING_REPORT-' + this.projectNameUrl + '.pdf')
      // var tweetVolumeImage = await getImage(this.$refs['tweetTypesVolumeLineChart'], 'tweetTypesVolumeLineChart')
      // this.doc.fromHTML(document.getElementById('tweetTypesVolumeLineChart').innerHTML, 15, 15, {
      //   'width': 170
      // })
      // this.doc.addImage(tweetVolumeImage, 'jpeg', 30, 180, 150, 24, '', 'NONE', 0)

      // for (var i = 0; i < this.doc.getNumberOfPages(); i++) {
      //   this.doc.setPage(i + 1)
      //   this.doc.setFontSize(11)
      //   this.doc.setFontStyle('normal')
      //   this.doc.text('General Monitoring Report', 15, 12.7)
      //   this.doc.setFontStyle('bold')
      //   this.doc.text(this.projectName, 90, 12.7)
      //   this.doc.setFontStyle('italic')
      //   this.doc.text('Period from ' + this.getFilters.fromDate + ' until ' + this.getFilters.toDate, 200, 12.7, {align: 'right'})
      //   this.doc.setFontStyle('normal')
      //   var text = i + 1
      //   this.doc.text(text.toString(), 105, 290, {align: 'center'})
      // }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Report.vue